import { QueryKey } from '@tanstack/react-query';

import { queryKeys } from '@/react-query/constants';
import { createFeatureApi } from '@/shared/api';

/** The orders feature roots on queryKeys.orders — the SAME cache root as bookings
 *  (bookings are order sub-resources), so order/booking invalidations stay coherent.
 *  Prefer keys.sub(orderId)/keys.detail(orderId) over keys.all for sub-resource ops
 *  to avoid invalidating sibling booking queries. Cross-cutting consumers invalidate
 *  via the re-exported `orderKeys`. */
export const ordersApi = createFeatureApi(queryKeys.orders);

export const orderKeys = ordersApi.keys;

/** Every cache entry scoped to one order: the detail read (`[orders, 'detail', id]`) that the
 *  order pages render from, plus the order-scoped sub-resources (`[orders, id, …]`).
 *  These are SIBLING subtrees — `keys.sub(id)` never prefix-matches `keys.detail(id)` — so a
 *  mutation that invalidates only one leaves the other stale until a page reload (AAD-3034).
 *  Any write that changes data the order pages display must invalidate through this helper. */
export const orderScopeKeys = (orderId: string): QueryKey[] => [
  orderKeys.sub(orderId),
  orderKeys.detail(orderId),
];
